export default __webpack_public_path__ + "static/media/regulatory--go-straight-bicycles--g1.d41deae5.png";